// Core component styles
const coreStyles = {
    expandContainer: {
        flexShrink: 0,
    },
    listToggler: {
        flexShrink: 0,
    },
};

/**
 * Helper method to get the styles for the component
 * @param {Object} contextStyles - Context styles for the Component
 */
const getStyles = (contextStyles = {}) => {
    return {
        expandContainer: {
            ...coreStyles.expandContainer,
            ...contextStyles.expandContainer,
        },
        menuContainer: {
            ...coreStyles.menuContainer,
            ...contextStyles.menuContainer,
        },
        listToggler: {
            ...coreStyles.listToggler,
            ...contextStyles.listToggler,
        },
    };
};

export default getStyles;
